function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-120 -5668)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 5346)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(120 170)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 152)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.375 10.5h-7.875v-1.5h-3v1.5h-7.188c-0.399 0-0.78 0.1575-1.062 0.4395l-2.0295 2.0295c-0.2925 0.294-0.2925 0.7695 0 1.062l2.0295 2.031c0.2805 0.2805 0.663 0.438 1.062 0.438h18.063c0.621 0 1.125-0.504 1.125-1.125v-3.75c0-0.621-0.504-1.125-1.125-1.125zm-10.875 12.75c0 0.414 0.336 0.75 0.75 0.75h1.5c0.414 0 0.75-0.336 0.75-0.75v-5.25h-3v5.25zm13.281-19.281-2.031-2.0295c-0.282-0.282-0.663-0.4395-1.0605-0.4395h-7.1895v-0.75c0-0.414-0.336-0.75-0.75-0.75h-1.5c-0.414 0-0.75 0.336-0.75 0.75v0.75h-7.875c-0.621 0-1.125 0.504-1.125 1.125v3.75c0 0.621 0.504 1.125 1.125 1.125h18.064c0.3975 0 0.7785-0.1575 1.0605-0.438l2.031-2.031c0.2925-0.294 0.2925-0.768 0-1.062z"
}))))));

var SvgAddress = function SvgAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address.75358888.svg";
export { ForwardRef as ReactComponent };